import script from "./VisorSoporte.vue?vue&type=script&setup=true&lang=js"
export * from "./VisorSoporte.vue?vue&type=script&setup=true&lang=js"

import "./VisorSoporte.vue?vue&type=style&index=0&id=ef48c61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef48c61e"]])

export default __exports__